import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AllUserProfilesGQL, UserProfile } from 'src/app/graphql/graphql';

@Component({
  selector: 'app-user-picker-customfield',
  templateUrl: './user-picker-customfield.component.html',
  styleUrls: ['./user-picker-customfield.component.scss']
})
export class UserPickerCustomfieldComponent implements OnInit, OnDestroy {
  @Input() label: string;
  @Input() valueController: FormGroup;

  users: UserProfile[] = [];
  usersOnSearch: UserProfile[];
  userSearchControl = new FormControl('');

  private destroy$ = new Subject<void>();

  constructor(private allUserProfilesGQL: AllUserProfilesGQL) {}

  ngOnInit(): void {
    this.allUserProfilesGQL.fetch({}).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.users = res.data.userprofiles || [];
      this.normalizeControlValue();
    });

    this.userSearchControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      const query = (value || '').toLowerCase();
      const selectedId = this.valueController.get('userValue').value;
      if (!query) {
        this.usersOnSearch = undefined;
        return;
      }
      this.usersOnSearch = this.users.filter(user =>
        this.fullName(user).toLowerCase().includes(query) || user.id === selectedId
      );
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  clearSearch(): void {
    this.userSearchControl.setValue('');
  }

  fullName(user: UserProfile): string {
    if (!user) {
      return '';
    }
    const first = user.user?.firstName || '';
    const last = user.user?.lastName || '';
    return `${first} ${last}`.trim();
  }

  private normalizeControlValue(): void {
    const control = this.valueController.get('userValue');
    const raw = control.value;
    if (raw && typeof raw === 'object' && raw.id) {
      control.setValue(raw.id, { emitEvent: false });
    }
  }
}
